import { apiClient } from '@/utils/api-client'

const API_BASE = import.meta.env.VITE_API_BASE
const API_INTERNAL_BASE = '/auth/password'

/**
 * Auth password service for password reset flows.
 */
class AuthPasswordService {
    /**
     * Validate a password reset token.
     *
     * @param {string} token - Password reset token
     * @returns {Promise<boolean>} True if token is valid
     */
    async check(token) {
        await apiClient.get(API_BASE + '/sanctum/csrf-cookie')

        return await apiClient
            .get(API_INTERNAL_BASE + '/' + token)
            .then(() => true)
            .catch(() => false)
    }
    /**
     * Confirm a password reset with new password.
     *
     * @param {string} token - Password reset token
     * @param {Object} password - Password payload
     * @param {string} password.password - New password
     * @param {string} password.confirm_password - Password confirmation
     * @returns {Promise<Object>} Confirmation response
     */
    async confirm(token, password) {
        await apiClient.get(API_BASE + '/sanctum/csrf-cookie')

        const response = await apiClient.put(API_INTERNAL_BASE + '/' + token, {
            password: password.password,
            confirm_password: password.confirm_password,
        })

        return response.data
    }
    /**
     * Request a password reset email.
     *
     * @param {Object} email - Email payload
     * @param {string} email.email - Email address
     * @returns {Promise<Object>} Reset request response
     */
    async create(email) {
        await apiClient.get(API_BASE + '/sanctum/csrf-cookie')

        const response = await apiClient.post(API_INTERNAL_BASE, {
            email: email.email,
            device_name: 'app-web',
        })

        return response.data
    }
}

export default new AuthPasswordService()
